// extracted by mini-css-extract-plugin
var _1 = "ExtensionMagneticWall-module__comment--XBLGF";
var _2 = "ExtensionMagneticWall-module__container--cqS52";
export { _1 as "comment", _2 as "container" }
